import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ShareMultiDropDownData {
  data?:any=undefined;
  private initialdata = new BehaviorSubject(this.data);
  currentData = this.initialdata.asObservable();

  constructor() {

   }
   shareMultiDropDownData(data: any) {
    this.initialdata.next(data)
  }

}
